var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "AllocateGroupsToConnection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v("Mapping Group Connection")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('legend', [_vm._v("Group List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                    Filter")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _c('br'), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('b-input-group', [_c('multiselect', {
    attrs: {
      "options": _vm.cityList,
      "name": "city",
      "label": "text",
      "track-by": "text",
      "placeholder": "Please Select City",
      "show-labels": false,
      "multiple": false,
      "max-height": 300,
      "clear-on-select": false,
      "limit": 1
    },
    on: {
      "select": _vm.selectedCity
    },
    model: {
      value: (_vm.city),
      callback: function($$v) {
        _vm.city = $$v
      },
      expression: "city"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Mode")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-automobile'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.routemodeList,
      "name": "selectedRouteMode",
      "label": "text",
      "track-by": "text",
      "placeholder": "Please Select Route Mode",
      "show-labels": false,
      "multiple": true,
      "max-height": 300,
      "clear-on-select": false,
      "limit": 2
    },
    model: {
      value: (_vm.selectedRouteMode),
      callback: function($$v) {
        _vm.selectedRouteMode = $$v
      },
      expression: "selectedRouteMode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Group Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.groupTypeList,
      "selected-option": _vm.groupTypeObjData,
      "name": "groupType",
      "placeholder": "Select Group Type"
    },
    on: {
      "select": _vm.selectedGroupType
    },
    model: {
      value: (_vm.groupType),
      callback: function($$v) {
        _vm.groupType = $$v
      },
      expression: "groupType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchAllGroups
    }
  }, [_vm._v("Search")]), _vm._v("   \n                                "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")])])], 1)], 1)])])])])], 1), _vm._v(" "), _c('div', {
    style: (_vm.groupsList.length > 10 ? 'overflow: auto; height: 380px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "height": "10px"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllGroups),
      expression: "checkAllGroups"
    }],
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "0.5%"
    },
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllGroups) ? _vm._i(_vm.checkAllGroups, null) > -1 : (_vm.checkAllGroups)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkAllGroups,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllGroups = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllGroups = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllGroups = $$c
        }
      }, function($event) {
        return _vm.checkGroup()
      }]
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("City ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Routemode ")])])]), _vm._v(" "), _c('tbody', [(_vm.groupsList.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupsList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.isselected),
        expression: "data.isselected"
      }],
      staticStyle: {
        "cursor": "pointer",
        "margin-left": "0.5%"
      },
      attrs: {
        "type": "checkbox",
        "id": "all"
      },
      domProps: {
        "checked": Array.isArray(data.isselected) ? _vm._i(data.isselected, null) > -1 : (data.isselected)
      },
      on: {
        "change": [function($event) {
          var $$a = data.isselected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(data, "isselected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(data, "isselected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(data, "isselected", $$c)
          }
        }, function($event) {
          return _vm.updateselected()
        }]
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.cityname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))])])
  })], 2)])])], 1)], 1)])], 1)])], 1)]), _vm._v(" "), _c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isConnLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isConnLoading = $event
      }
    }
  }), _vm._v(" "), _c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v(" Connection List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitSearch.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Connection Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cubes'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-1.connectionTypeID')
    },
    attrs: {
      "options": _vm.connectionTypeList,
      "selected-option": _vm.connectionTypeObjData,
      "name": "connectionTypeID",
      "placeholder": "Please Select Connection Type"
    },
    on: {
      "select": _vm.selectedConnectionType
    },
    model: {
      value: (_vm.connectionTypeID),
      callback: function($$v) {
        _vm.connectionTypeID = $$v
      },
      expression: "connectionTypeID"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.connectionTypeID')),
      expression: "errors.has('form-1.connectionTypeID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Connection Type field is\n                required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Origin Hub"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    attrs: {
      "options": _vm.HubList,
      "name": "hubName",
      "label": "text",
      "track-by": "text",
      "placeholder": "Please Select Origin Hub",
      "show-labels": false,
      "multiple": false,
      "max-height": 300,
      "clear-on-select": false,
      "limit": 1
    },
    on: {
      "select": _vm.selectedOriginHub
    },
    model: {
      value: (_vm.hubName),
      callback: function($$v) {
        _vm.hubName = $$v
      },
      expression: "hubName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.hubName')),
      expression: "errors.has('form-1.hubName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Origin Hub field is\n                required.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Connection"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-plug'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-1.connectionid')
    },
    attrs: {
      "options": _vm.connectionList,
      "selected-option": _vm.connectionObjData,
      "name": "connectionid",
      "placeholder": "Please Select Connection"
    },
    on: {
      "select": _vm.selectedConnection
    },
    model: {
      value: (_vm.connectionid),
      callback: function($$v) {
        _vm.connectionid = $$v
      },
      expression: "connectionid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.connectionid')),
      expression: "errors.has('form-1.connectionid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Connection field is\n                required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100",
      "margin-top": "15px"
    },
    attrs: {
      "name": "allowBagpattern"
    },
    model: {
      value: (_vm.allowBagpattern),
      callback: function($$v) {
        _vm.allowBagpattern = $$v
      },
      expression: "allowBagpattern"
    }
  }, [_vm._v(" Allow Baggin Pattern")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-danger",
    staticStyle: {
      "margin-left": "83%"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetDiv
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.confirmationModal = false
      }
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Connection will be mapped to selected Groups. Do you want to proceed?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mapconnectiontogroups
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d8695d","hasScoped":true}!./src/views/components/groupnew/AllocateGroupsToConnection/AllocateGroupsToConnection.html
// module id = 1938
// module chunks = 2